import { useState, useEffect, StrictMode } from 'react';
import { SearchBar } from '../../molecules';
import { CardItemContainer } from '../../atoms';
import { useChatList } from '../../../hooks';

const ListOfChats = ({ currentChat, onSelect, setIndex }) => {
  const { chats } = useChatList();
  const [search, setSearch] = useState("");

  const onSubmitSearch = (e) => {
    e.preventDefault();
    onSelect(null);
    setSearch(e.target.value)
  }

  const onChangeInputValue = (_, value) => {
    setSearch(value);
  }


  const renderChats = () => {
    if (chats.length == 0) return;
    return chats.filter(chat => {
      if (search) {
        return (chat.nome || "").toUpperCase().indexOf(search.toUpperCase()) > -1;
      }
      return true;
    }).map((chat, index) => {
      return (<tr
        onClick={() => {
          if (chat == currentChat) {
            onSelect(null);
            setIndex(null);
          } else {
            setIndex(index);
            onSelect(chat)
          }
        }}
        key={chat.id}
        className={chat == currentChat ? "selected" : undefined}
      >
        <td>{!chat.was_read_adm ? <div className="dot"></div> : null}</td>
        <td>{chat.nome}</td>
        <td className="text-right">{chat.data}</td>
      </tr>)
    }
    )
  }

  return (
    <div className="row">
      <div className="col-12 list-of-chats-container">
        <div className="row mb-3">
          <div className="col-md-8">
            <SearchBar onSubmit={onSubmitSearch} onChangeInputValue={onChangeInputValue} />
          </div>
        </div>
        <CardItemContainer className="list-of-chats">
          <div className="w-100">
            <table className="table">
              <thead>
                <tr>
                  <th></th>
                  <th>Nome</th>
                  <th className="text-right">Data da útilma mensagem</th>
                </tr>
              </thead>
              <tbody>
                {renderChats()}
              </tbody>
            </table>
          </div>
        </CardItemContainer>
      </div>
    </div>
  );
}

export { ListOfChats };
